import initialState from 'redux/initial-states/support';
import reportAProblem from './reportAProblem';

export default (state = initialState, action = {}) => ({
  ...state,
  ...reportAProblem(state, action),
});
